export default "__VITE_ASSET__83178590__"